
import { Component, Prop, Vue } from "vue-property-decorator";
import LsHeader from "@/components/layout/header.vue";
import Layout from "@/layout/index.vue";
import LsAside from "@/components/layout/aside.vue";
import { State, Getter, Action } from "vuex-class";

@Component({
  components: {
    LsHeader,
    Layout,
    LsAside,
  },
})
export default class Aside extends Vue {
  leftBarShow = true;

  @Getter("permission") permission: any;

  get asideMenu() {
    const { meta } = this.$route;
    let modulePath: any = "";
    for (let i = 0; i < this.permission?.routes.length; i++) {
      const element = this.permission?.routes[i];
      if (element.path === meta?.parentPath) {
        modulePath = element.path;
        break;
      } else {
        element.children.forEach((child: any) => {
          if (child.path === meta?.parentPath) {
            modulePath = child.meta.parentPath;
          }
        });
      }
    }
    let moduleItem = this.permission?.routes.find(
      (element: any) => element.path === modulePath,
    );
    return moduleItem?.children || [];
  }
  get hideAsideMenu() {
    if (!this.asideMenu) {
      return true;
    } else {
      return (
        this.asideMenu &&
        this.asideMenu?.every((item: any) => item.meta?.hidden)
      );
    }
  }

  created() {
    // console.log('???')
  }
}
